<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button (click)="cancel()">
        @if (modeService.isIosMode()) {
        <div>Zurück</div>
        } @if (!modeService.isIosMode()) {
        <div>
          <ion-icon
            name="arrow-back-outline"
            slot="icon-only"
            size="medium"
          ></ion-icon>
        </div>
        }
      </ion-button>
    </ion-buttons>
    <ion-title>Als E-Mail versenden</ion-title>
    <ion-buttons slot="end">
      <ion-button
        id="popover-button"
        [strong]="true"
        [disabled]="!mailForm.valid"
        (click)="sendMail()"
      >
        <ion-icon name="send-outline" slot="icon-only" size="small"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content>
  <form [formGroup]="mailForm">
    <ion-item lines="full">
      <ion-input
        type="text"
        placeholder="E-Mail"
        label="An "
        formControlName="mail"
      ></ion-input>
    </ion-item>
    <ion-item lines="full">
      <ion-input
        type="text"
        placeholder="Betreff"
        formControlName="subject"
      ></ion-input>
    </ion-item>
    <ion-item lines="full" class="h-80">
      <ion-textarea
        class="h-80 textarea"
        placeholder="Nachricht"
        formControlName="message"
      ></ion-textarea>
    </ion-item>
    <ion-item lines="none">
      <ion-toggle formControlName="saveAsTemplate"
        >Als Standardnachricht speichern</ion-toggle
      >
    </ion-item>
    <ion-item lines="none">
      <ion-toggle formControlName="sendCopy">Kopie an mich senden</ion-toggle>
    </ion-item>
    @if (customerSignal().stripe_onboarding_completed && invoiceAddRequest() && invoiceAddRequest()?.total_amount > 0 && (customerEntitlementsSignal()?.includes(Plans.premium) || customerEntitlementsSignal()?.includes(Plans.premium_promo))) {
      <ion-item lines="none">
        <ion-toggle formControlName="enableOnlinePayment">Online Zahlung</ion-toggle>
      </ion-item>
    }
  </form>
</ion-content>
